const awards = [
    { id: 1, award: "Best paper award at the 27th International Conference on Evaluation and Assessment in Software Engineering, 2023" },
    { id: 2, award: "Best paper award at the 17th International Conference on Software and System Processes, 2023" },
    { id: 3, award: "CAREER Award, given by TUBITAK (Scientific and Technological Research Council of Turkey), 2022" },
    { id: 4, award: "Associate Professor title, given by the Inter-University Council (UAK) of Turkey, 2021" },
    { id: 5, award: "Best paper award at 13th ACM/IEEE International Symposium on Empirical Software Engineering and Measurement (ESEM) 2019" },
    { id: 6, award: "METU Parlar PhD Thesis of the Year Award, 2014" },
];

export default awards;
